import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CognitoAuthService } from '@app/auth/services/cognito-auth.service';
import { RdrAuthService } from '@app/auth/services/rdr-auth.service';
import { FeatureToggleService, RdrFeature } from '@app/ui/services/feature-toggle.service';
import { Observable, concatMap, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchFlightsRedirectGuard {
  constructor(
    private router: Router,
    private cognitoAuthService: CognitoAuthService,
    private rdrAuthService: RdrAuthService,
    private featureToggleService: FeatureToggleService,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.cognitoAuthService.hasCognitoSession().pipe(
      concatMap(() => this.rdrAuthService.getUser()),
      map(() => {
        // Only a new search moves to Complex Search. search-flights/<id> is an existing
        // standard search, which Complex Search cannot open (BASI-234).
        if (
          this.featureToggleService.isFeatureEnabled(RdrFeature.complex_search_flights) &&
          this.isNewSearch(state.url)
        ) {
          return this.router.createUrlTree(['/complex-search-flights']);
        }

        return true;
      }),
    );
  }

  private isNewSearch(url: string) {
    const segments = this.router.parseUrl(url).root.children['primary']?.segments || [];

    return segments[segments.length - 1]?.path === 'search-flights';
  }
}
